import script from "./StudioPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioPanel.vue?vue&type=script&setup=true&lang=js"

import "./StudioPanel.vue?vue&type=style&index=0&id=70da5cef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70da5cef"]])

export default __exports__